import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import AutoComplete from '../MultiAutoComplete';

const AVAILABLE_PERMISSIONS = ['Administrator', 'Read Only'];

const buildOption = (permission) => ({ label: permission, value: permission });

const fetchSuggestions = (permissions) => {
  return (query) => {
    const lcQuery = (query || '').toLowerCase();
    return Promise.resolve(permissions.filter((p) => p.toLowerCase().indexOf(lcQuery) >= 0).slice(0, 10))
      .then((permissions) => permissions.map(buildOption));
  };
};

class Permissions extends React.Component {
  state = {
    permission: '',
  };

  handleKeyPress = (evt) => {
    console.log('handleKeyPress', this.state);
    if (evt.key === 'Enter') {
      this.addPermission();
    }

    evt.stopPropagation();
  };

  addPermission = () => {
    const { permission } = this.state;
    if (permission && permission.trim()) {
      this.props.onChange(_.concat(this.props.permissions, [permission]));
      this.setState({
        permission: '',
      });
    }
  };

  handlePermissionChange = (permissions, valid) => {
    console.log('handlePermissionChange', permissions, valid);
    this.setState({
      permissions,
    });
  };

  render() {
    const { permissions, onChange, label, helperText } = this.props;
    return (
      <AutoComplete
        label={label}
        helperText={helperText}
        loadOptions={fetchSuggestions(AVAILABLE_PERMISSIONS)}
        value={(permissions || []).map(buildOption)}
        onChange={(value) => onChange(value.map(opt => opt.value))}
        id="permissions"
        isMulti
        placeholder="Add new permission..."
      />);
  }
};

Permissions.propTypes = {
  permissions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  showAll: PropTypes.bool,
};

export default Permissions;



// WEBPACK FOOTER //
// ./src/components/Common/Permissions/index.js